import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

const resources = {
  en: { translation: en },
  es: { translation: es }
};

i18n
  .use(LanguageDetector) // Detecta idioma del navegador
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Idioma por defecto si no detecta
    
    interpolation: {
      escapeValue: false // React ya escapa los valores
    },
    
    detection: {
      // Orden de detección: localStorage primero, luego navegador
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'zensaver_language',
      caches: ['localStorage']
    }
  });

// Función helper para cambiar idioma y guardarlo
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('zensaver_language', lng);
};

// Función para obtener idioma actual
export const getCurrentLanguage = () => {
  return i18n.language || 'en';
};

export default i18n;
